module.exports = __webpack_public_path__ + "img/IMG_1962_P_Wood.a22672ab.jpg";